import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const Delivery20: FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path fillRule="evenodd" clipRule="evenodd" d="M12.8183 5C13.1339 5 13.4225 5.17834 13.5637 5.46066L15.8333 10L17.0393 10.603C17.3217 10.7442 17.5 11.0327 17.5 11.3484V13.3333C17.5 13.7936 17.1269 14.1667 16.6667 14.1667H15.8333C15.8333 15.0871 15.0871 15.8333 14.1667 15.8333C13.2462 15.8333 12.5 15.0871 12.5 14.1667H7.5C7.5 15.0871 6.75381 15.8333 5.83333 15.8333C4.91286 15.8333 4.16667 15.0871 4.16667 14.1667H3.33333C2.8731 14.1667 2.5 13.7936 2.5 13.3333V5.83333C2.5 5.3731 2.8731 5 3.33333 5H12.8183ZM12.5 6.66667H10.8333V10H14.1667L12.5 6.66667ZM8.33333 9.16667H5V10H8.33333V9.16667ZM8.33333 6.66667H5V7.5H8.33333V6.66667Z" fill={color} />
      </svg>
    </IconContainer>
  );
};
